import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const Root = () => {
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent);
      const isSmallScreen = window.innerWidth < 1024; // Blocks small screens even in "Desktop Mode"

      if (isMobileDevice || isSmallScreen) {
        setIsBlocked(true);
      } else {
        setIsBlocked(false);
      }
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);

    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);

  if (isBlocked) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f8d7da",
        color: "#721c24",
        fontSize: "20px",
        padding: "20px",
      }}>
        ⚠️ This application only works on a desktop.  
        Please open it on a PC or laptop.
      </div>
    );
  }

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
